var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.58337 3C1.89327 3 1.33337 3.5599 1.33337 4.25C1.33337 4.64323 1.51827 5.01302 1.83337 5.25L7.50004 9.5C7.79692 9.72135 8.20317 9.72135 8.50004 9.5L14.1667 5.25C14.4818 5.01302 14.6667 4.64323 14.6667 4.25C14.6667 3.5599 14.1068 3 13.4167 3H2.58337ZM1.33337 5.91667V11.3333C1.33337 12.2526 2.08077 13 3.00004 13H13C13.9193 13 14.6667 12.2526 14.6667 11.3333V5.91667L9.00004 10.1667C8.40629 10.612 7.59379 10.612 7.00004 10.1667L1.33337 5.91667Z",
    fill: "#6D738D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f5ce77acb1120d7c8c31e7895efd3483.svg";
export { ForwardRef as ReactComponent };